import $ from "/js/libs/jquery-3.3.1.min.js"
import {gsap, selector} from "/js/libs/gsap/all.js"

export class Avatar {

  constructor(selector = "#avatar") {
    this.selector = selector;
    this.el = $(selector);
    this.timelines = {
      happy: this.buildHappyTimeline(),
      surprised: this.buildSurprisedTimeline(),
      laughing: this.buildLaughingTimeline()
    };

    this.floatingTimeline = this.buildFloatingTimeline();

    gsap.set(this.el.find(`.avatar-type`), {
      autoAlpha: 0,
    })
  }

  setFloating(enable) {
    if (enable) {
      this.floatingTimeline.play();
    } else {
      this.floatingTimeline.pause();
    }
  }

  buildFloatingTimeline() {
    const tl = gsap.timeline({
      paused: true
    });
    tl.fromTo(this.el.find(`.wrapper`), {
      y: 0,
    }, {
      y: 50,
      repeat: -1,
      duration: 1.5,
      yoyo: true,
      ease: "power1.inOut",
    })
    return tl;
  }

  setAvatar(type, repeat = false, repeatDelay = 0) {

    const tl = gsap.timeline({});

    if (this.el.find(`.avatar-type.active`).length > 0) {
      tl.to(this.el.find(`.avatar-type.active`), {
        autoAlpha: 0,
        duration: 0.5,
      })
    }

    tl.add(() => {
      this.stopAllAnimation();
    });

    if (type) {

      tl.add(() => {
        this.el.find(`.avatar-type.${type}`).addClass("active");
        this.timelines[type].repeatDelay(repeatDelay);
        this.timelines[type].repeat((repeat ? -1 : 1));
        this.timelines[type].restart();
      });

      tl.fromTo(this.el.find(`.avatar-type.${type}`), {
        scale: 0.95
      }, {
        autoAlpha: 1,
        scale: 1,
        duration: 0.5,
      })
    }
  }

  buildHappyTimeline() {

    const tl = gsap.timeline({
      paused: true,
    });

    ['left', 'right'].forEach((eye) => {

      tl.fromTo(this.el.find(`.happy-eye-${eye}`), {
        scale: 0.5,
      }, {
        scale: 1,
        duration: 2.0,
        ease: "power1.out",
      }, 0);

      tl.fromTo(this.el.find(`.happy-eye-${eye}-eclat-1, .happy-eye-${eye}-eclat-2`), {
        autoAlpha: 0,
      }, {
        autoAlpha: 1,
        duration: 0.5
      }, 1.5);

      const eclatTl = gsap.timeline({
        duration: 4
      });

      eclatTl.fromTo(this.el.find(`.happy-eye-${eye}-eclat-1`), {
        scale: 0.8,
      }, {
        scale: 1,
        duration: 0.15,
        ease: "linear",
        yoyo: true,
        repeat: 20,
      }, 0.0);

      eclatTl.fromTo(this.el.find(`.happy-eye-${eye}-eclat-2`), {
        scale: 0.8,
      }, {
        scale: 1,
        duration: 0.15,
        ease: "linear",
        yoyo: true,
        repeat: 20,
      }, 0.15);

      tl.add(eclatTl, 1.5)

      tl.to(this.el.find(`.happy-eye-${eye}-eclat-1, .happy-eye-${eye}-eclat-2`), {
        autoAlpha: 0,
        duration: 0.5
      }, 4.5);

      tl.to(this.el.find(`.happy-eye-${eye}`), {
        scale: 0.5,
        duration: 2.0,
        ease: "power1.out",
      }, 4.8);
    })

    return tl;
  }

  buildSurprisedTimeline() {

    const tl = gsap.timeline({
      paused: true,
    });

    tl.fromTo(this.el.find(`.surprised-mouth`), {
      scaleY: 0.8,
    }, {
      scaleY: 1,
      duration: 0.5,
      yoyo: true,
      repeat: 7,
    });

    ['left', 'right'].forEach((eye) => {
      const eyesTl = gsap.timeline({
        repeat: 1
      });

      eyesTl.fromTo(this.el.find(`.surprised-eye-${eye}`), {
        x: 0,
        y: 0,
      }, {
        x: 50,
        y: 30,
        duration: 0.5,
        ease: "linear",
      });
      eyesTl.to(this.el.find(`.surprised-eyebrow-${eye}`), {
        y: -25,
        duration: 0.5,
        ease: "linear",
      }, "<");

      eyesTl.to(this.el.find(`.surprised-eye-${eye}`), {
        x: 0,
        y: 0,
        duration: 0.5,
        ease: "linear",
      });
      eyesTl.to(this.el.find(`.surprised-eyebrow-${eye}`), {
        y: 0,
        duration: 0.5,
        ease: "linear",
      }, "<");

      eyesTl.to(this.el.find(`.surprised-eye-${eye}`), {
        x: -50,
        y: 30,
        duration: 0.5,
        ease: "linear",
      })
      eyesTl.to(this.el.find(`.surprised-eyebrow-${eye}`), {
        y: -25,
        duration: 0.5,
        ease: "linear",
      }, "<");

      eyesTl.to(this.el.find(`.surprised-eye-${eye}`), {
        x: 0,
        y: 0,
        duration: 0.5,
        ease: "linear",
      });
      eyesTl.to(this.el.find(`.surprised-eyebrow-${eye}`), {
        y: 0,
        duration: 0.5,
        ease: "linear",
      }, "<");

      tl.add(eyesTl, 0);
    })


    return tl;
  }

  buildLaughingTimeline() {

    const tl = gsap.timeline({
      paused: true,
    });

    tl.fromTo(this.el.find(`.laughing-face`), {
      y: 0,
      scaleY: 1,
    }, {
      y: 10,
      scaleY: 0.95,
      duration: 0.4,
      yoyo: true,
      ease: "power1.inOut",
      repeat: 7,
    });

    return tl;
  }

  stopAllAnimation() {
    Object.keys(this.timelines).forEach((key) => {
      this.timelines[key].pause();
    });

  }

}
